module.exports = __webpack_public_path__ + "media/application/images/2018/facebook-white-a984db2a5253e3af5bf692d6b02d40a6.svg";